import { DefaultLevelSettings } from '../../Game/Enums';

const defaultState = {
    title: DefaultLevelSettings.title,
    description: DefaultLevelSettings.description,
    backgroundColorA: DefaultLevelSettings.backgroundA,
    backgroundColorB: DefaultLevelSettings.backgroundB,
    view: DefaultLevelSettings.view,
    timeLimit: DefaultLevelSettings.timeLimit,
    pointsGoal: DefaultLevelSettings.pointsGoal
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'LEVEL_SETTINGS_SET_ALL': {
            return {
                ...action.payload
            };
        }
        case 'LEVEL_SETTINGS_SET': {
            const newState = state;
            const { payload } = action;

            if ('title' in payload) {
                newState.title = payload.title;
            }
            if ('description' in payload) {
                newState.description = payload.description;
            }
            if ('timeLimit' in payload) {
                newState.timeLimit = payload.timeLimit;
            }
            if ('pointsGoal' in payload) {
                newState.pointsGoal = payload.pointsGoal;
            }
            if ('backgroundColorA' in payload) {
                newState.backgroundColorA = payload.backgroundColorA;
            }
            if ('backgroundColorB' in payload) {
                newState.backgroundColorB = payload.backgroundColorB;
            }
            if ('view' in payload) {
                newState.viewDirection = payload.view;
            }
            
            return newState;
        }
        case 'LEVEL_SETTINGS_SET_VIEW': {
            return {
                ...state,
                view: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
